// Plain TS constants (not an AngularJS `.constant()`) so Angular components — which have no
// automatic bridge for injecting AngularJS `.constant()` values, unlike a handful of explicitly
// upgraded services (see splitServiceProvider in app.module.ts) — can import these directly
// instead of failing to construct with "No provider for planningConstants".
// projects-constants.constant.ts re-exports these into `planningConstants` for AngularJS consumers.
//
// Keyed by Record<Enum, string> rather than a loose string-indexed map so the compiler catches a
// missing/typo'd/stale key against the enum's actual members.
import {DraftJobChangeType} from "../types/draft-job-change-type.enum";
import {DraftJobChangeStatus} from "../types/draft-job-change-status.enum";
import {DraftJobChangesSyncState} from "../types/draft-job-changes-sync-state.enum";

export const draftJobChangeTypeColorMap: Record<DraftJobChangeType, string> = {
  [DraftJobChangeType.UPDATE]: '#DEF2FC',
  [DraftJobChangeType.REMOVE]: '#FFECEC',
  [DraftJobChangeType.ADD_JOB]: '#E9F7E9',
  [DraftJobChangeType.SPLIT_JOB]: '#F0EAF6',
  [DraftJobChangeType.REMOVE_JOB]: '#FFECEC',
  [DraftJobChangeType.BLOCKED]: '#F0F0F0'
};

export const draftJobChangeStatusColorMap: Record<DraftJobChangeStatus, string> = {
  [DraftJobChangeStatus.PENDING]: '#DEF2FC',
  [DraftJobChangeStatus.FAILED]: '#FFECEC'
};

export const draftJobChangesSyncStateColorMap: Record<DraftJobChangesSyncState, string> = {
  [DraftJobChangesSyncState.SCANNING]: '#F0EAF6',
  [DraftJobChangesSyncState.CHANGES_READY]: '#DEF2FC',
  [DraftJobChangesSyncState.APPLYING]: '#F0EAF6',
  [DraftJobChangesSyncState.SYNCED]: '#E9F7E9',
  [DraftJobChangesSyncState.FAILED]: '#FFECEC'
};
